import { isFalse, isTruthy } from './boolean.js';
import { isNeitherNullNorUndefined } from './guard.js';
const isBrowser = () => {
    return typeof window !== 'undefined';
};
const getPreferredMode = () => {
    if (isFalse(isBrowser())) {
        return 'dark';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
};
const formQueryParamStringFromRecord = (params) => {
    return Object.entries(params)
        .flatMap(([key, value]) => {
        return !value ? [] : [[key, value]];
    })
        .map(([key, value]) => {
        return `${key}=${encodeURIComponent(!Array.isArray(value) ? value : value.filter(isTruthy).join(','))}`;
    })
        .join('&');
};
const formQueryParamRecordFromString = (queryParam) => {
    return queryParam
        .split('&')
        .map((queryParamUnit) => {
        return queryParamUnit.split('=');
    })
        .flatMap(([key, value]) => {
        return !(isNeitherNullNorUndefined(key) &&
            isNeitherNullNorUndefined(value))
            ? []
            : [[key, value]];
    })
        .map(([key, value]) => {
        const decodedValue = decodeURIComponent(value);
        return {
            key,
            value: decodedValue.includes(',')
                ? decodedValue.split(',')
                : decodedValue,
        };
    })
        .reduce((record, { key, value }) => {
        return {
            ...record,
            [key]: value,
        };
    }, {});
};
export { isBrowser, getPreferredMode, formQueryParamStringFromRecord, formQueryParamRecordFromString, };
//# sourceMappingURL=web.js.map